import { useEffect, useMemo, useState } from "react";
import { publicApi, type Incident } from "../../lib/api";
import { IncidentList } from "../../components/IncidentList";

function padMonth(n: number): string {
  return n < 10 ? `0${n}` : `${n}`;
}

export function ArchivePage() {
  const now = new Date();
  const [year, setYear] = useState<string>(String(now.getUTCFullYear()));
  const [month, setMonth] = useState<string>(
    padMonth(now.getUTCMonth() + 1),
  );
  const [incidents, setIncidents] = useState<Incident[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    async function load() {
      try {
        const resp = await publicApi.archive(year, month);
        if (!cancelled) {
          setIncidents(resp.incidents);
          setError(null);
        }
      } catch (e) {
        if (!cancelled) {
          setError(e instanceof Error ? e.message : "unknown_error");
        }
      }
    }
    void load();
    return () => {
      cancelled = true;
    };
  }, [year, month]);

  const months = useMemo(() => {
    return Array.from({ length: 12 }, (_, i) => padMonth(i + 1));
  }, []);

  return (
    <section className="mx-auto max-w-5xl px-4 py-10">
      <h1 className="text-2xl font-semibold">Incident archive</h1>
      <p className="mt-2 text-slate-600">
        Resolved incidents and completed maintenance, by month.
      </p>
      <form
        className="mt-6 flex gap-3"
        onSubmit={(e) => e.preventDefault()}
      >
        <label className="flex items-center gap-2 text-sm">
          Year
          <input
            className="rounded border border-slate-300 px-2 py-1"
            value={year}
            onChange={(e) => setYear(e.target.value)}
            inputMode="numeric"
            pattern="\d{4}"
            aria-label="Year"
          />
        </label>
        <label className="flex items-center gap-2 text-sm">
          Month
          <select
            className="rounded border border-slate-300 px-2 py-1"
            value={month}
            onChange={(e) => setMonth(e.target.value)}
            aria-label="Month"
          >
            {months.map((m) => (
              <option key={m} value={m}>
                {m}
              </option>
            ))}
          </select>
        </label>
      </form>
      {error ? (
        <p className="mt-4 text-sm text-red-700">Archive unavailable.</p>
      ) : (
        <IncidentList
          title={`Incidents in ${year}-${month}`}
          incidents={incidents}
          emptyMessage="No incidents recorded for this month."
        />
      )}
    </section>
  );
}
